export const safeLocalStorageGet = <T>(
    key: string,
    parse: (v: string) => T | null,
    fallback: T
): T => {
    try {
        if (typeof window === 'undefined') return fallback
        const raw = window.localStorage.getItem(key)
        return raw ? (parse(raw) ?? fallback) : fallback
    } catch {
        return fallback
    }
}

export const safeLocalStorageSet = (key: string, value: string): void => {
    try {
        if (typeof window !== 'undefined') {
            window.localStorage.setItem(key, value)
        }
    } catch (error) {
        console.warn('storage unavailable:', error)
    }
}
